import { createFileRoute } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { organizationQueries } from '@/features/organizations/queries';
import { SettingsTab } from '@/features/organizations/components/settings-tab/SettingsTab';
import { OrgSettingsTabSkeleton } from '@/common/components/loading-skeleton/OrgSettingsTabSkeleton';

export const Route = createFileRoute('/_authenticated/organizations/$organizationId/settings')({
  component: RouteComponent,
  pendingComponent: OrgSettingsTabSkeleton,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  const { data: org } = useSuspenseQuery(organizationQueries.detail(organizationId));
  if (!org) return null;
  return <SettingsTab org={org} orgId={organizationId} />;
}
